import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { Button } from 'antd';
import 'antd/dist/antd.css';

import './App.css';
import FileSaver from 'file-saver';

import { TOGGLE_IMITATION } from '../actions/types';
import ImitatorAndEditor from './ImitatorAndEditor';
import UpLoadButton from './UploadButton';

class App extends Component {
  constructor(props) {
    super();

    this.saveTextToFile = this.saveTextToFile.bind(this);
    this.toggleImitation = this.toggleImitation.bind(this);
  }

  renderHideButton() {
    if (this.props.ShowImitation) {
      return 'Hide Imitation Page';
    } else {
      return 'Show Imitation Page';
    }
  }

  toggleImitation() {
    this.props.dispatch({ type: TOGGLE_IMITATION });
  }

  // save the text as plain txt file
  saveTextToFile(text) {
    const content = new Blob([text], { type: 'text/plain;charset=utf-8' });
    FileSaver.saveAs(content, 'Your_Hard_Work.txt');
  }

  render() {
    return (
      <div className="App">
        <div className="top-bar">
          <Button className="btn" onClick={this.toggleImitation}>
            {this.renderHideButton()}
          </Button>
          <Button
            className="btn"
            onClick={event => {
              this.saveTextToFile(this.props.Text);
            }}>
            Save File
          </Button>
          <UpLoadButton extensions={['txt']} />
        </div>
        <ImitatorAndEditor />
      </div>
    );
  }
}

App.propTypes = {
  Text: PropTypes.string,
  ShowImitation: PropTypes.bool,
  dispatch: PropTypes.func
};

function mapStateToProps(state) {
  return {
    ShowImitation: state.ShowImitation,
    Text: state.Text
  };
}

export default connect(
  mapStateToProps,
  null
)(App);



// WEBPACK FOOTER //
// ./src/containers/App.js